// extracted by mini-css-extract-plugin
export default {"list":"list___ab28cd72e3c5596e","answer":"answer___d57e5488be85ff46","label":"label___a1f5a2c0cf3e0334","field":"field___dc86b2fecb4b4941"};